import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    searchModelName: '',
    searchModelGoBackURL: ''
};
export const monitoringSearchModelSlice = createSlice({
    name: 'monitoringSearchModel',
    initialState,
    reducers: {
        setSearchModelName: (state, action) => {
            state.searchModelName = action.payload;
        },
        setSearchModelGoBackURL: (state, action) => {
            state.searchModelGoBackURL = action.payload;
        },
        clearSearchModelState: () => initialState
    }
});
export const { setSearchModelName, setSearchModelGoBackURL, clearSearchModelState } = monitoringSearchModelSlice.actions;
export default monitoringSearchModelSlice.reducer;
